export const LOGIN_ROUTE = '/login'
export const LOGIN_ROUTE_NEW = '/app/login-new'
export const MICROSOFT_REDIRECT_ROUTE = '/microsoft-redirect'
export const RECOVER_PASSWORD_ROUTE = '/app/recover-password'
export const BOLSON_FORM_ROUTE = '/bolson'
export const SUPPORT_ROUTE = '/app/help'
export const CREATE_CAMPAIGN_ROUTE = '/app/create-campaign'
export const CREATE_CAMPAIGN_TOPUP_ROUTE = '/app/create-campaign-topup'
export const GET_SCHEDULED_TOPUP_ROUTE = '/app/get-schedule-topup'
export const TEMPLATES_ROUTE = '/app/templates'
export const TEMPLATES_EMAIL_ROUTE = '/app/templates/email'
export const TEMPLATES_WHATSAPP_ROUTE = '/app/templates/whatsapp'
export const COMPANYS_ROUTE = '/app/companys'
export const BLACKLIST_ROUTE = '/app/blacklist'
export const GET_SCHEDULED_SHIPMENTS_ROUTE = '/app/get-schedule-shipments'
export const GET_PROMOCIONAL_CODE_ROUTE = '/app/get-promocional-code'
export const GET_PURCHASE_FREQUENCY_ROUTE = '/app/get-purchase-frequency'
export const GET_RECHARGE_FREQUENCY_ROUTE = '/app/get-recharge-frequency'
export const SEND_VOUCHERS_BY_LOTS = '/app/send-vouchers-by-lots'
export const TOPUP_ROUTE = '/app/topup'
export const VOUCHERS_SENT_ROUTE = '/app/current-account'
export const CURRENT_ACCOUNT_ROUTE = '/app/vouchers-sent'
export const PUSH_MONEY_CREATE_ORDER_ROUTE = '/app/purchase-request'
export const PUSH_MONEY_EDIT_ORDER_ROUTE = '/app/purchase-request/:id'
export const CREATE_CODES_ROUTE = '/app/create-codes'
export const WALLET_CREDITED_BALANCE = '/app/wallet-credited-balance'
export const LIST_PUSH_MONEY_ORDERS_ROUTE = '/app/orders'
export const WALLET_EXPIRED_BALANCE = '/app/wallet-expired-balance'
export const BENEFICIARIES = '/app/beneficiaries'
export const RECHARGES_BY_GROUP = '/app/recharges-by-group'
export const INVOICES = '/app/invoices'
export const REDEMPTION_SUMMARY_ROUTE = '/app/redemption-summary'
export const REPORT_VOUCHERS_SENT_ROUTE = '/app/report-vouchers-sent'

export const CREATE_PROFILE_ROUTE = '/app/create-profile'
export const VERIFY_NUMBER_ROUTE = '/verify-code'

export const LANDING_ROUTE = '/japon'
export const CHANGE_PASSWORD = '/app/change-password'
export const PRIMARY = '/app/home'
export const PRODUCT_CATALOG = '/app/product-catalog'
export const PRODUCT_CATALOG_ADMIN = '/app/product-catalog-admin'
export const UPLOAD_IMAGES_ADMIN = '/app/upload-images-admin'
export const BALANCE_ROUTE = '/app/balance'
export const BALANCE_TRANSFER_ROUTE = '/app/balance-transfer'
export const BOLSON_PROFILE_ROUTE = '/app/bolson-profile'

/* Marketplace */
export const MARKETPLACE_ROUTE = '/app/marketplace'
export const PARTNER_ROUTE = '/app/partner'
export const VOUCHERS_ROUTE = '/app/vouchers'
export const SELECTED_VOUCHER_ROUTE = '/app/selected-voucher'
export const CONTACTS_ROUTE = '/app/contacts'
export const CHECKOUT_ROUTE = '/app/checkout'
export const VALE_SENT_ROUTE = '/app/vale-sent'
export const HISTORY_ROUTE = '/app/history'

export const HELP_ROUTE = '/app/help'

export const VISIBILITY_BY_BENEFICIARY_ROUTE = '/app/visibility-by-beneficiary'

export const VISIBILITY_BY_REFERENCE_ROUTE = '/app/visibility-by-reference'

export const VOUCHERS_BY_WALLET_ROUTE = '/app/vouchers-by-wallet'

export const PARTNER_BY_CATEGORY_ROUTE = '/app/partners-category'

export const REPORT_RESELLER_SALES_ROUTE = '/app/report-reseller-sales'

export const SECONDARY_REPORT_INVOICES_ROUTE = '/app/secondary-reports/recargas'

export const SECONDARY_REPORT_VOUCHERS_ROUTE = '/app/secondary-reports/vales'

export const BULK_VOUCHER_ORDER_ROUTE = '/app/reseller-bulk-order'

export const RESELLER_VOUCHER_BATCHES_ROUTE = '/app/reseller-voucher-batches'
